// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9b32583d","389":"3c4fbb3f","732":"dc7e779f","977":"2a1bb104"}[chunkId] + ".chunk.js";
};